import yaml from 'js-yaml'

import envConfig from './env-config'

export const loadYAML = (path: string) => {
  return fetch(`${envConfig.i18nStoreOrigin}/${path}.yaml`)
    .then((res) => {
      return res.text()
    })
    .then((d) => yaml.load(d))
}
